import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ProfessionalsAPI from '../../api/professionals';
import { extractRecord, extractList } from '../utils/appointmentEnvelope';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchError: false,
  },
};

export const getters = {
  getProfessionals(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getProfessionalById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getProfessionals({ commit }) {
    commit(types.SET_PROFESSIONAL_UI_FLAG, {
      isFetching: true,
      isFetchError: false,
    });
    try {
      const response = await ProfessionalsAPI.get();
      commit(types.SET_PROFESSIONALS, extractList(response));
    } catch {
      commit(types.SET_PROFESSIONAL_UI_FLAG, { isFetchError: true });
    } finally {
      commit(types.SET_PROFESSIONAL_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createProfessional({ commit }, professionalData) {
    commit(types.SET_PROFESSIONAL_UI_FLAG, { isCreating: true });
    try {
      const response = await ProfessionalsAPI.create(professionalData);
      commit(types.ADD_PROFESSIONAL, extractRecord(response));
      return extractRecord(response);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_PROFESSIONAL_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateProfessional({ commit }, { id, ...updateData }) {
    commit(types.SET_PROFESSIONAL_UI_FLAG, { isUpdating: true });
    try {
      const response = await ProfessionalsAPI.update(id, updateData);
      commit(types.EDIT_PROFESSIONAL, extractRecord(response));
      return extractRecord(response);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_PROFESSIONAL_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteProfessional({ commit }, id) {
    commit(types.SET_PROFESSIONAL_UI_FLAG, { isDeleting: true });
    try {
      await ProfessionalsAPI.delete(id);
      commit(types.DELETE_PROFESSIONAL, id);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_PROFESSIONAL_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_PROFESSIONAL_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_PROFESSIONALS]: MutationHelpers.set,
  [types.ADD_PROFESSIONAL]: MutationHelpers.create,
  [types.EDIT_PROFESSIONAL]: MutationHelpers.update,
  [types.DELETE_PROFESSIONAL]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
